import { createSelector } from 'reselect';
import { getBidderEmail } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import { postConfirmPassword } from '@/redux/api/auth';

/* Action Types */
export const CONFIRM_PASSWORD_FAIL = 'la/ui/confirmPassword/FAIL';
export const CONFIRM_PASSWORD_REQUEST = 'la/ui/confirmPassword/REQUEST';
export const CONFIRM_PASSWORD_SUCCESS = 'la/ui/confirmPassword/SUCCESS';

// reducer
const DEFAULT_STATE = {
    error: false,
    errorMessage: null,
    submitted: false,
    success: false,
};

export type State = typeof DEFAULT_STATE & {
    errorMessage: string | null | undefined;
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case CONFIRM_PASSWORD_REQUEST:
            return {
                ...state,
                error: false,
                errorMessage: null,
                submitted: true,
                success: false,
            };
        case CONFIRM_PASSWORD_SUCCESS:
            return {
                ...state,
                submitted: false,
                success: true,
            };
        case CONFIRM_PASSWORD_FAIL:
            return {
                ...state,
                error: true,
                errorMessage: action.payload.message,
                submitted: false,
                success: false,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.confirmPassword;

export const getUiConfirmPassword = createSelector(stateSelector, (state) => state);

/* ACTION CREATORS */
export const submitConfirmPassword = (password: string) => async (dispatch: Function, getState: Function) => {
    try {
        dispatch({
            type: CONFIRM_PASSWORD_REQUEST,
        });
        const state = getState();
        const username = getBidderEmail(state);
        const deployment = getDeployment(state);
        const response = await postConfirmPassword({ deployment, password, username });
        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: CONFIRM_PASSWORD_SUCCESS,
        });
    } catch (error) {
        if (error.message === 'Failed to get the login.') {
            dispatch({
                error: true,
                payload: { message: 'Invalid password' },
                type: CONFIRM_PASSWORD_FAIL,
            });
        } else {
            dispatch({
                error: true,
                payload: error,
                type: CONFIRM_PASSWORD_FAIL,
            });
        }
    }
};
